import React, { useState, useEffect } from 'react';
import { tagsMapFor } from '../../../data/tagAssignments';
import API from '../../../data/api';

/**
 * Loads the User tags and maps each promoter to the tags it carries, for the
 * "Etiquetas" column filter.
 */
export function usePromoterTags(promoters) {
    const [availableTags, setAvailableTags] = useState([]);
    const [promoterTagsMap, setPromoterTagsMap] = useState({});

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const api = API.Instance();
                const response = await api.requestTags({ modelType: 'User' });
                const tags = response.tags || [];
                setAvailableTags(tags);

                // One request for every row's tags (data/tagAssignments.js)
                const tagsMap = await tagsMapFor(promoters, 'User', tags);
                setPromoterTagsMap(tagsMap);
            } catch (error) {
                console.error('Error fetching tags:', error);
            }
        };
        if (promoters && promoters.length > 0) {
            fetchTags();
        }
    }, [promoters]);

    return { availableTags, promoterTagsMap };
}

/** Name search with autocomplete suggestions; filters the visible rows through `setRows`. */
export function usePromoterSearch(promoters, setRows) {
    const [suggestions, setSuggestions] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');

    const onSearch = (search) => {
        try {
            setSearchValue(search);
            if (!search || typeof search !== 'string') {
                setSuggestions([]);
                setRows(promoters);
                return;
            }

            const filteredData = promoters.filter((c) => c.name && c.name.toLowerCase().includes(search.toLowerCase()));
            setRows(filteredData);
            setSuggestions(filteredData?.map((c) => c.name) ?? []);
        } catch (error) {
            console.warn('Error in promoter search:', error);
            setSuggestions([]);
        }
    };

    return { suggestions, searchValue, setSearchValue, onSearch };
}

/** Compliance % → design-system tone. */
export const complianceTone = (percentage) => {
    const value = parseFloat(percentage) || 0;
    if (value >= 80) return 'success';
    if (value >= 50) return 'warning';
    return 'danger';
};
